(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block.product-bulk-order-v2"] && !Shopify.designMode) return;
  try {
    class BulkOrderMatrixV2 extends HTMLElement {
    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('.bulk-order__qty'))
      this.submitBtn = this.querySelector('[data-submit]')
      this.totalCountEl = this.querySelector('[data-total-count]')
      this.totalPriceEl = this.querySelector('[data-total-price]')
      this.errorEl = this.querySelector('[data-error]')
      this.custBar = this.querySelector('[data-cust-bar]')
      this.custBarText = this.querySelector('[data-cust-bar-text]')
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}'

      this.inputs.forEach((input) => {
        input.addEventListener('input', () => this.onQtyChange())
        input.addEventListener('change', () => this.onQtyChange())
      })

      this.querySelectorAll('.bulk-order__qty-btn--minus').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = btn.nextElementSibling
          const val = Math.max(0, (parseInt(input.value, 10) || 0) - 1)
          input.value = val
          this.onQtyChange()
        })
      })

      this.querySelectorAll('.bulk-order__qty-btn--plus').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = btn.previousElementSibling
          const val = (parseInt(input.value, 10) || 0) + 1
          input.value = val
          this.onQtyChange()
        })
      })

      this.submitBtn.addEventListener('click', () => this.onSubmit())
      this.updateSummary()
      this.updateCustBar()

      // Re-check status bar when customization is saved
      document.addEventListener('ei:customization-saved', () => this.updateCustBar())

      // Embroidery setup fee config
      this.embroideryFeeVariantId = this.dataset.embroideryFeeVariantId || null
      this.embroideryFeeThreshold = parseInt(this.dataset.embroideryFeeThreshold, 10) || 24

      // Click on color image → change main product gallery image
      this.querySelectorAll('[data-bulk-color-img]').forEach((img) => {
        img.addEventListener('click', () => {
          const fullSrc = img.dataset.fullSrc
          if (!fullSrc) return

          // Extract the base filename (without size/params) for matching
          const srcBase = fullSrc.split('?')[0].split('/').pop().replace(/_\d+x\d*/, '').replace(/_\d+x/, '')

          // Try product-images (classic gallery with Flickity)
          const gallery = document.querySelector('product-images')
          if (gallery && gallery.flickity) {
            const slides = gallery.querySelectorAll('.product-main-slide img, .product-main-slide .image-element')
            for (let i = 0; i < slides.length; i++) {
              const slideSrc = (slides[i].src || slides[i].dataset.photoswipeSrc || '').split('?')[0].split('/').pop().replace(/_\d+x\d*/, '').replace(/_\d+x/, '')
              if (slideSrc && slideSrc === srcBase) {
                gallery.flickity.goToSlide(i)
                break
              }
            }
            return
          }

          // Fallback: try media-gallery (flex PDP)
          const flexGallery = document.querySelector('media-gallery')
          if (flexGallery && typeof flexGallery.goToSlide === 'function') {
            const slides = flexGallery.querySelectorAll('[data-media-id] img')
            for (let i = 0; i < slides.length; i++) {
              const slideSrc = (slides[i].src || '').split('?')[0].split('/').pop().replace(/_\d+x\d*/, '').replace(/_\d+x/, '')
              if (slideSrc && slideSrc === srcBase) {
                flexGallery.goToSlide(i)
                break
              }
            }
          }
        })
      })
    }

    onQtyChange() {
      this.updateSummary()
      this.updateRowTotals()
      this.updateCustBar()
    }

    updateCustBar() {
      if (!this.custBar || !this.custBarText) return

      const totalQty = this.inputs.reduce((acc, input) => {
        return acc + Math.max(0, parseInt(input.value, 10) || 0)
      }, 0)

      if (totalQty === 0) {
        this.custBar.setAttribute('hidden', '')
        return
      }

      const state = window.__EI_CUSTOMIZATION__

      this.custBar.removeAttribute('hidden')
      this.custBar.classList.remove('bov2-cust-bar--warn', 'bov2-cust-bar--ok')

      if (!state || !state.method) {
        this.custBar.classList.add('bov2-cust-bar--warn')
        this.custBarText.textContent = 'Customization not saved — click Customize before adding to cart.'
      } else {
        this.custBar.classList.add('bov2-cust-bar--ok')
        let summary = state.method
        if (state.instructions) summary += ' — ' + state.instructions.slice(0, 50)
        if (state.artworkUrl) summary += ' + artwork'
        this.custBarText.textContent = 'Customization saved: ' + summary
      }
    }

    updateSummary() {
      let totalQty = 0
      let totalCents = 0

      this.inputs.forEach((input) => {
        const qty = Math.max(0, parseInt(input.value, 10) || 0)
        if (qty > 0) {
          totalQty += qty
          totalCents += qty * (parseInt(input.dataset.variantPrice, 10) || 0)
        }
      })

      if (this.totalCountEl) {
        this.totalCountEl.textContent = totalQty === 1 ? '1 item' : `${totalQty} items`
      }

      if (this.totalPriceEl) {
        this.totalPriceEl.innerHTML = totalQty > 0 ? this.formatMoney(totalCents) : ''
      }

      if (this.submitBtn) {
        this.submitBtn.disabled = totalQty === 0
      }
    }

    updateRowTotals() {
      const rowTotalCells = this.querySelectorAll('[data-row-total]')
      rowTotalCells.forEach((cell) => {
        const row = cell.closest('tr')
        if (!row) return
        let rowCents = 0
        let rowQty = 0
        row.querySelectorAll('.bulk-order__qty').forEach((input) => {
          const qty = Math.max(0, parseInt(input.value, 10) || 0)
          rowQty += qty
          rowCents += qty * (parseInt(input.dataset.variantPrice, 10) || 0)
        })
        cell.innerHTML = rowQty > 0 ? this.formatMoney(rowCents) : ''
      })
    }

    async onSubmit() {
      const cust = window.__EI_CUSTOMIZATION__ || {}

      const items = []
      this.inputs.forEach((input) => {
        const qty = Math.max(0, parseInt(input.value, 10) || 0)
        if (qty > 0) {
          const item = {
            id: parseInt(input.dataset.variantId, 10),
            quantity: qty
          }

          // Attach customization as line item properties if present
          if (cust.method) {
            item.properties = {
              'Customization': cust.method,
              'Instructions': cust.instructions || '',
              'Artwork': cust.artworkUrl || ''
            }

            // Hide empty artwork from checkout display (prefix with underscore)
            if (!cust.artworkUrl) {
              delete item.properties['Artwork']
            }
          }

          items.push(item)
        }
      })

      if (items.length === 0) return

      this.setLoading(true)
      this.clearError()

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items, sections: ['cart-ajax'] })
        })

        const responseData = await response.json()

        if (!response.ok) {
          this.showError(responseData.description || responseData.message || 'Could not add items to cart.')
          return
        }

        this.inputs.forEach((input) => { input.value = '0' })
        this.updateSummary()
        this.updateRowTotals()
        this.updateCustBar()

        // Manage embroidery setup fee based on total embroidery items in cart
        await this.manageEmbroideryFee()

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: responseData }
        }))

      } catch (err) {
        this.showError('An error occurred. Please try again.')
      } finally {
        this.setLoading(false)
      }
    }

    async manageEmbroideryFee() {
      if (!this.embroideryFeeVariantId) return

      try {
        const cartRes = await fetch(`${window.Shopify.routes.root}cart.js`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        const cart = await cartRes.json()

        // Count total qty of items that have Embroidery customization
        let embroideryQty = 0
        let feeLineIndex = null

        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i]
          if (String(item.variant_id) === String(this.embroideryFeeVariantId)) {
            feeLineIndex = i + 1 // Shopify uses 1-based line index
            continue
          }
          if (item.properties && item.properties['Customization'] === 'Embroidery') {
            embroideryQty += item.quantity
          }
        }

        if (embroideryQty > 0 && embroideryQty < this.embroideryFeeThreshold && feeLineIndex === null) {
          // Add the setup fee
          await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{ id: parseInt(this.embroideryFeeVariantId, 10), quantity: 1 }]
            })
          })
        } else if ((embroideryQty >= this.embroideryFeeThreshold || embroideryQty === 0) && feeLineIndex !== null) {
          // Remove the setup fee using line index
          await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ line: feeLineIndex, quantity: 0 })
          })
        }
      } catch (e) {
        // Silently fail — fee management is non-critical
        console.warn('Embroidery fee check failed:', e)
      }
    }

    setLoading(on) {
      if (!this.submitBtn) return
      if (on) {
        this.submitBtn.setAttribute('data-loading', '')
        this.submitBtn.disabled = true
      } else {
        this.submitBtn.removeAttribute('data-loading')
        this.updateSummary()
      }
    }

    showError(message) {
      if (!this.errorEl) return
      this.errorEl.textContent = message
      this.errorEl.setAttribute('data-visible', '')
    }

    clearError() {
      if (!this.errorEl) return
      this.errorEl.textContent = ''
      this.errorEl.removeAttribute('data-visible')
    }

    formatMoney(cents) {
      const format = this.moneyFormat
      const match = format.match(/\{\{\s*(\w+)\s*\}\}/)
      if (!match) return `${(cents / 100).toFixed(2)}`

      const type = match[1]

      const withDelimiters = (num, precision, thousands, decimal) => {
        precision = precision !== undefined ? precision : 2
        thousands = thousands || ','
        decimal = decimal || '.'
        const str = (num / 100).toFixed(precision)
        const parts = str.split('.')
        const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`)
        return parts[1] !== undefined ? whole + decimal + parts[1] : whole
      }

      let value
      switch (type) {
        case 'amount': value = withDelimiters(cents, 2); break
        case 'amount_no_decimals': value = withDelimiters(cents, 0); break
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break
        default: value = withDelimiters(cents, 2)
      }

      return format.replace(/\{\{\s*\w+\s*\}\}/, value)
    }
  }

  if (!customElements.get('bulk-order-matrix-v2')) {
    customElements.define('bulk-order-matrix-v2', BulkOrderMatrixV2)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["block.product-bulk-order"] && !Shopify.designMode) return;
  try {
    class BulkOrderMatrix extends HTMLElement {
    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('.bulk-order__qty'))
      this.submitBtn = this.querySelector('[data-submit]')
      this.totalCountEl = this.querySelector('[data-total-count]')
      this.totalPriceEl = this.querySelector('[data-total-price]')
      this.errorEl = this.querySelector('[data-error]')
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}'

      this.inputs.forEach((input) => {
        input.addEventListener('input', () => this.onQtyChange())
        input.addEventListener('change', () => this.onQtyChange())
      })

      this.querySelectorAll('.bulk-order__qty-btn--minus').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = btn.nextElementSibling
          const val = Math.max(0, (parseInt(input.value, 10) || 0) - 1)
          input.value = val
          this.onQtyChange()
        })
      })

      this.querySelectorAll('.bulk-order__qty-btn--plus').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = btn.previousElementSibling
          const val = (parseInt(input.value, 10) || 0) + 1
          input.value = val
          this.onQtyChange()
        })
      })

      this.submitBtn.addEventListener('click', () => this.onSubmit())
      this.updateSummary()
    }

    onQtyChange() {
      this.updateSummary()
      this.updateRowTotals()
    }

    updateSummary() {
      let totalQty = 0
      let totalCents = 0

      this.inputs.forEach((input) => {
        const qty = Math.max(0, parseInt(input.value, 10) || 0)
        if (qty > 0) {
          totalQty += qty
          totalCents += qty * (parseInt(input.dataset.variantPrice, 10) || 0)
        }
      })

      if (this.totalCountEl) {
        this.totalCountEl.textContent = totalQty === 1 ? '1 item' : `${totalQty} items`
      }

      if (this.totalPriceEl) {
        this.totalPriceEl.innerHTML = totalQty > 0 ? this.formatMoney(totalCents) : ''
      }

      if (this.submitBtn) {
        this.submitBtn.disabled = totalQty === 0
      }
    }

    updateRowTotals() {
      const rowTotalCells = this.querySelectorAll('[data-row-total]')
      rowTotalCells.forEach((cell) => {
        const row = cell.closest('tr')
        if (!row) return
        let rowCents = 0
        let rowQty = 0
        row.querySelectorAll('.bulk-order__qty').forEach((input) => {
          const qty = Math.max(0, parseInt(input.value, 10) || 0)
          rowQty += qty
          rowCents += qty * (parseInt(input.dataset.variantPrice, 10) || 0)
        })
        cell.innerHTML = rowQty > 0 ? this.formatMoney(rowCents) : ''
      })
    }

    async onSubmit() {
      const items = []
      this.inputs.forEach((input) => {
        const qty = Math.max(0, parseInt(input.value, 10) || 0)
        if (qty > 0) {
          items.push({ id: parseInt(input.dataset.variantId, 10), quantity: qty })
        }
      })

      if (items.length === 0) return

      this.setLoading(true)
      this.clearError()

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items, sections: ['cart-ajax'] })
        })

        const responseData = await response.json()

        if (!response.ok) {
          this.showError(responseData.description || responseData.message || 'Could not add items to cart.')
          return
        }

        this.inputs.forEach((input) => { input.value = '0' })
        this.updateSummary()
        this.updateRowTotals()

        // Fire ajaxProduct:added with sections — this updates the cart drawer HTML
        // and opens it (handled by header-cart-drawer component)
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: responseData }
        }))

      } catch (err) {
        this.showError('An error occurred. Please try again.')
      } finally {
        this.setLoading(false)
      }
    }

    setLoading(on) {
      if (!this.submitBtn) return
      if (on) {
        this.submitBtn.setAttribute('data-loading', '')
        this.submitBtn.disabled = true
      } else {
        this.submitBtn.removeAttribute('data-loading')
        this.updateSummary()
      }
    }

    showError(message) {
      if (!this.errorEl) return
      this.errorEl.textContent = message
      this.errorEl.setAttribute('data-visible', '')
    }

    clearError() {
      if (!this.errorEl) return
      this.errorEl.textContent = ''
      this.errorEl.removeAttribute('data-visible')
    }

    formatMoney(cents) {
      const format = this.moneyFormat
      const match = format.match(/\{\{\s*(\w+)\s*\}\}/)
      if (!match) return `${(cents / 100).toFixed(2)}`

      const type = match[1]

      const withDelimiters = (num, precision, thousands, decimal) => {
        precision = precision !== undefined ? precision : 2
        thousands = thousands || ','
        decimal = decimal || '.'
        const str = (num / 100).toFixed(precision)
        const parts = str.split('.')
        const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`)
        return parts[1] !== undefined ? whole + decimal + parts[1] : whole
      }

      let value
      switch (type) {
        case 'amount': value = withDelimiters(cents, 2); break
        case 'amount_no_decimals': value = withDelimiters(cents, 0); break
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break
        default: value = withDelimiters(cents, 2)
      }

      return format.replace(/\{\{\s*\w+\s*\}\}/, value)
    }
  }

  if (!customElements.get('bulk-order-matrix')) {
    customElements.define('bulk-order-matrix', BulkOrderMatrix)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["block.product-customize-v2"] && !Shopify.designMode) return;
  try {
    class CustomizeDialogV2 extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cust-dialog]')
      this.statusBar = this.querySelector('[data-cust-status]')
      this.statusText = this.querySelector('[data-cust-status-text]')
      this.detailsStep = this.querySelector('[data-cust-details]')
      this.textArea = this.querySelector('[data-cust-text]')
      this.counter = this.querySelector('[data-cust-counter]')
      this.fileInput = this.querySelector('[data-cust-file]')
      this.fileNameEl = this.querySelector('[data-cust-file-name]')
      this.uploadProgress = this.querySelector('[data-cust-upload-progress]')
      this.errorEl = this.querySelector('[data-cust-error]')
      this.saveBtn = this.querySelector('[data-cust-save]')
      this.methodBtns = Array.from(this.querySelectorAll('[data-method]'))
      this.uploadVariantId = this.dataset.uploadVariantId

      this.selectedMethod = ''
      this.pendingFile = null
      this.savedArtworkUrl = ''

      // Open triggers (button + status edit link)
      this.querySelectorAll('[data-cust-open]').forEach((el) => {
        el.addEventListener('click', () => this.openDialog())
      })

      // Close button
      const closeBtn = this.querySelector('[data-cust-close]')
      if (closeBtn) closeBtn.addEventListener('click', () => this.closeDialog())

      // Click on backdrop (the dialog element itself, outside inner)
      if (this.dialog) {
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.closeDialog()
        })
        // Prevent default Escape close so we can control it
        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault()
          this.closeDialog()
        })
      }

      // Method buttons
      this.methodBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (btn.disabled) return
          this.selectMethod(btn.dataset.method, btn)
        })
      })

      // Character counter
      if (this.textArea) {
        this.textArea.addEventListener('input', () => this.updateCounter())
      }

      // File change
      if (this.fileInput) {
        this.fileInput.addEventListener('change', () => this.onFileChange())
      }

      // Save
      if (this.saveBtn) {
        this.saveBtn.addEventListener('click', () => this.save())
      }

      // Restore any previously saved state
      this.restoreState()
    }

    openDialog() {
      if (this.dialog && !this.dialog.open) this.dialog.showModal()
    }

    closeDialog() {
      if (this.dialog && this.dialog.open) this.dialog.close()
    }

    selectMethod(method, btn) {
      this.selectedMethod = method
      this.methodBtns.forEach((b) => b.removeAttribute('data-selected'))
      btn.setAttribute('data-selected', '')
      if (this.detailsStep) this.detailsStep.removeAttribute('hidden')
    }

    updateCounter() {
      if (!this.textArea || !this.counter) return
      this.counter.textContent = this.textArea.value.length + ' / 60'
    }

    onFileChange() {
      const file = this.fileInput && this.fileInput.files[0]
      const MAX = 5 * 1024 * 1024

      if (!file) {
        this.pendingFile = null
        if (this.fileNameEl) this.fileNameEl.textContent = 'Click to upload artwork (optional)'
        return
      }

      if (file.size > MAX) {
        this.fileInput.value = ''
        this.pendingFile = null
        if (this.fileNameEl) this.fileNameEl.textContent = 'Click to upload artwork (optional)'
        this.showError('File exceeds 5 MB limit. Please choose a smaller file.')
        return
      }

      this.pendingFile = file
      this.savedArtworkUrl = '' // new file invalidates previous upload
      if (this.fileNameEl) this.fileNameEl.textContent = file.name
      this.hideError()
    }

    async save() {
      this.hideError()

      if (!this.selectedMethod) {
        this.showError('Please select DTF Print or Embroidery.')
        return
      }

      const text = this.textArea ? this.textArea.value.trim() : ''
      if (!text) {
        this.showError('Please enter placement and instructions details.')
        return
      }

      let artworkUrl = this.savedArtworkUrl

      // Upload new file if one was picked
      if (this.pendingFile && this.uploadVariantId) {
        const result = await this.uploadFile(this.pendingFile)
        if (result === null) return // error already shown
        artworkUrl = result
        this.savedArtworkUrl = artworkUrl
        this.pendingFile = null
      }

      window.__EI_CUSTOMIZATION__ = {
        method: this.selectedMethod,
        instructions: text,
        artworkUrl: artworkUrl || ''
      }

      this.updateStatus(window.__EI_CUSTOMIZATION__)
      document.dispatchEvent(new CustomEvent('ei:customization-saved', { detail: window.__EI_CUSTOMIZATION__ }))
      this.closeDialog()
    }

    async uploadFile(file) {
      if (this.uploadProgress) this.uploadProgress.removeAttribute('hidden')
      if (this.saveBtn) this.saveBtn.disabled = true

      try {
        const formData = new FormData()
        formData.append('id', this.uploadVariantId)
        formData.append('quantity', '1')
        formData.append('properties[Artwork]', file)

        const addRes = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })

        if (!addRes.ok) {
          const err = await addRes.json().catch(() => ({}))
          this.showError(err.description || 'Failed to upload artwork. Please try again.')
          return null
        }

        const addData = await addRes.json()
        // /cart/add.js returns the line item directly for a single FormData POST
        const items = addData.items || [addData]
        let uploadedUrl = ''
        let itemKey = ''

        for (const item of items) {
          if (String(item.variant_id) === String(this.uploadVariantId)) {
            itemKey = item.key
            const props = item.properties || {}
            uploadedUrl = props['Artwork'] || props['artwork'] || ''
            break
          }
        }

        // Remove the temporary dummy cart item
        if (itemKey) {
          await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: itemKey, quantity: 0 })
          }).catch(() => {})
        }

        if (!uploadedUrl) {
          this.showError('Artwork uploaded but URL was not returned. Please try again.')
          return null
        }

        return uploadedUrl

      } catch (err) {
        this.showError('Upload failed: ' + (err.message || 'unknown error'))
        return null
      } finally {
        if (this.uploadProgress) this.uploadProgress.setAttribute('hidden', '')
        if (this.saveBtn) this.saveBtn.disabled = false
      }
    }

    updateStatus(state) {
      if (!this.statusBar || !this.statusText) return
      let summary = state.method
      if (state.instructions) {
        const trunc = state.instructions.length > 40
          ? state.instructions.slice(0, 40) + '…'
          : state.instructions
        summary += ' — ' + trunc
      }
      if (state.artworkUrl) summary += ' + artwork'
      this.statusText.textContent = summary
      this.statusBar.removeAttribute('hidden')
    }

    restoreState() {
      const state = window.__EI_CUSTOMIZATION__
      if (!state || !state.method) return

      const matchBtn = this.methodBtns.find((b) => b.dataset.method === state.method)
      if (matchBtn) this.selectMethod(state.method, matchBtn)

      if (this.textArea && state.instructions) {
        this.textArea.value = state.instructions
        this.updateCounter()
      }

      this.savedArtworkUrl = state.artworkUrl || ''
      if (this.savedArtworkUrl && this.fileNameEl) {
        this.fileNameEl.textContent = 'Artwork already uploaded ✓'
      }

      this.updateStatus(state)
    }

    showError(msg) {
      if (!this.errorEl) return
      this.errorEl.textContent = msg
      this.errorEl.removeAttribute('hidden')
    }

    hideError() {
      if (!this.errorEl) return
      this.errorEl.setAttribute('hidden', '')
    }
  }

  if (!customElements.get('customize-dialog-v2')) {
    customElements.define('customize-dialog-v2', CustomizeDialogV2)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super()
      this.select = null
      this.buttonText = null
      this.button = null
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select')
      this.button = this.querySelector('.element-button')

      if (this.select && this.button) {
        this.init()
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-text') || this.button.querySelector('[data-button-text]')

      // Set initial text
      this.updateButtonText()

      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e))

      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e))

      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText())

      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus())
      this.select.addEventListener('blur', () => this.handleBlur())
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault()
      e.stopPropagation()

      // Trigger the native select
      this.select.focus()
      this.select.click()
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault()
          this.select.click()
          break
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break
        default:
          // Let other keys pass through
          break
      }
    }

    updateButtonText() {
      if (!this.buttonText) return

      const selectedOption = this.select.options[this.select.selectedIndex]
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option'
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused')
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused')
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e))
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e))
        this.select.removeEventListener('change', () => this.updateButtonText())
        this.select.removeEventListener('focus', () => this.handleFocus())
        this.select.removeEventListener('blur', () => this.handleBlur())
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.customer"] && !Shopify.designMode) return;
  try {
    class FormCustomer extends HTMLElement {
    static emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

    connectedCallback() {
      this.controller?.abort()
      const { signal } = (this.controller = new AbortController())

      const form = this.querySelector('form')
      const input = form?.querySelector('input[name="contact[email]"]')
      if (!input) return

      const validate = () => {
        const ok = FormCustomer.emailPattern.test(input.value.trim())
        input.setCustomValidity(ok ? '' : this.dataset.invalidMessage)
      }

      input.addEventListener('input', validate, { signal })
      form.addEventListener(
        'submit',
        (e) => {
          validate()
          if (!form.reportValidity()) e.preventDefault()
        },
        { signal, passive: false }
      )
    }

    disconnectedCallback() {
      this.controller?.abort()
    }
  }

  customElements.define('form-customer', FormCustomer)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super()
      this.form = this.querySelector('form')
      this.submitButton = this.findSubmitButton()
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]')
      return submitButton
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true
        this.submitButton.classList.add('product-form__submit-button--pulsing')
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false
        this.submitButton.classList.remove('product-form__submit-button--pulsing')
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault()

      // Disable submit button and start pulsing
      this.disableSubmitButton()

      // Get cart state before form submission
      let cartBeforeSubmission
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
        cartBeforeSubmission = await cartResponse.json()
      } catch (error) {
        console.error('Failed to get cart state before submission:', error)
        cartBeforeSubmission = null
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }

      const formData = new FormData(this.form)

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData
          },
          cancelable: true
        })
      )

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise((resolve) => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve)
      })

      config.body = formData

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      })

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent)
      let responseData

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse()
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config)
          responseData = await response.json()

          if (!response.ok) {
            throw responseData
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
        const cartAfterSubmission = await cartResponse.json()

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            }
          })
        )

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              }
            })
          )
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        })

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent)

        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            }
          })
        )
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton()
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject }

        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver
            reject(new Error('Cart request timeout - no response received from subscriber'))
          }
        }, 30000) // 30 second timeout

        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout
      })
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout)
        this._cartRequestResolver.resolve(responseData)
        delete this._cartRequestResolver
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout)
        this._cartRequestResolver.reject(error)
        delete this._cartRequestResolver
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter)
    }
  }

  customElements.define('product-form', ProductForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super()

      // Pull localized error message from data attributes
      this.formId = this.dataset.formId
      this.defaultErrorMessage = this.dataset.error
      this.defaultSuccessMessage = this.dataset.success

      // Create abort controller for event cleanup
      this.abortController = new AbortController()
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate()
      this.bindEvents()
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort()
    }

    cacheTemplate() {
      const template = this.querySelector('template')
      if (template) {
        this.template = template.innerHTML
        this.templateElement = template
      }
    }

    bindEvents() {
      const { signal } = this.abortController

      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal })

      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal })

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal })
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      this.clearMessages()
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      let message = this.defaultSuccessMessage

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      })

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent)

      if (eventCancelled) {
        return
      }

      this.showMessage(successMessageEvent.detail.message)
    }

    handleError(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      const error = e.detail.error
      let message = this.defaultErrorMessage

      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description
      } else if (error.message) {
        message = error.message
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      })

      const eventCancelled = !this.dispatchEvent(errorMessageEvent)

      if (eventCancelled) {
        return
      }

      this.showMessage(errorMessageEvent.detail.message)
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages()
      this.classList.remove('hide')

      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message)

        // Insert the error message content
        this.innerHTML = messageContent
      }
    }

    clearMessages() {
      this.classList.add('hide')

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-grid', LayoutGrid)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-stack', LayoutStack)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }

    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    function animateWithClass(element, className) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return Promise.resolve()
    }

    return new Promise((resolve) => {
      function handleAnimationEnd(event) {
        if (event.target === element) {
          element.removeEventListener('animationend', handleAnimationEnd)
          element.classList.remove(className)
          resolve()
        }
      }
      element.addEventListener('animationend', handleAnimationEnd)
      element.classList.add(className)
    })
  }

  class OverlayDrawer extends HTMLElement {
    #dialog = null
    #originalTrigger = null
    #abortController = null

    connectedCallback() {
      this.#dialog = this.querySelector('dialog')
      if (!this.#dialog) return

      this.#abortController = new AbortController()
      const { signal } = this.#abortController

      this.#dialog.addEventListener('cancel', (e) => this.#handleCancel(e), { signal })
      this.#dialog.addEventListener('click', (e) => this.#handleClick(e), { signal })
      this.#dialog.addEventListener('pointerdown', (e) => this.#handlePointerDown(e), { signal })
    }

    disconnectedCallback() {
      this.#abortController?.abort()
    }

    get lightDismiss() {
      return this.getAttribute('light-dismiss') !== 'false'
    }

    async show() {
      if (this.#dialog.open) return

      const showEvent = new CustomEvent('drawer:show', {
        bubbles: true,
        cancelable: true
      })
      this.dispatchEvent(showEvent)
      if (showEvent.defaultPrevented) return

      this.#originalTrigger = document.activeElement
      this.#dialog.showModal()

      await animateWithClass(this.#dialog, 'overlay-drawer--show')

      requestAnimationFrame(() => {
        // Only set focus if nothing inside the dialog is already focused
        if (!this.#dialog.contains(document.activeElement)) {
          const elementToFocus = this.#dialog.querySelector('[autofocus]')
          elementToFocus?.focus() ?? this.#dialog.focus()
        }
      })

      this.dispatchEvent(new CustomEvent('drawer:after-show', { bubbles: true }))
    }

    async hide(source = this) {
      if (!this.#dialog.open) return

      const hideEvent = new CustomEvent('drawer:hide', {
        bubbles: true,
        cancelable: true,
        detail: { source }
      })
      this.dispatchEvent(hideEvent)

      if (hideEvent.defaultPrevented) {
        await animateWithClass(this.#dialog, 'overlay-drawer--pulse')
        return
      }

      await animateWithClass(this.#dialog, 'overlay-drawer--hide')
      this.#dialog.close()

      if (this.#originalTrigger?.focus) {
        setTimeout(() => {
          try {
            this.#originalTrigger.focus({ preventScroll: true })
          } catch {
            this.#originalTrigger.focus()
          }
        }, 0)
      }

      this.dispatchEvent(new CustomEvent('drawer:after-hide', { bubbles: true }))
    }

    #handleCancel(event) {
      event.preventDefault()
      this.hide(this)
    }

    #handleClick(event) {
      const closeButton = event.target.closest('[data-drawer="close"]')
      if (closeButton) {
        event.stopPropagation()
        this.hide(closeButton)
      }
    }

    async #handlePointerDown(event) {
      if (event.target !== this.#dialog) return

      const rect = this.#dialog.getBoundingClientRect()
      const isClickInsideDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom

      if (!isClickInsideDialog) {
        if (this.lightDismiss) {
          this.hide(this)
        } else {
          await animateWithClass(this.#dialog, 'overlay-drawer--pulse')
        }
      }
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer)

  // Global trigger handler
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-drawer]')
    if (!trigger) return

    const attr = trigger.getAttribute('data-drawer')
    if (!attr) return

    const [command, id] = attr.trim().split(/\s+/)

    if (command === 'open' && id) {
      const drawer = document.getElementById(id)
      if (drawer?.tagName === 'OVERLAY-DRAWER') {
        event.preventDefault()
        drawer.show()
      }
    }
  })

  // Safari fix for backdrop clicks
  document.body.addEventListener('pointerdown', () => {})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map()
    // Track which groups have been prefetched
    static prefetchedGroups = new Set()

    constructor() {
      super()
      this.trigger = null
      this.template = null
      this.overlay = null
      this.closeBtn = null
      this.prevBtn = null
      this.nextBtn = null
      this.group = this.dataset.group
      this.groupItems = []
      this.currentIndex = 0

      // Register this instance
      if (this.group) {
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, [])
        }
        OverlayLightbox.registry.get(this.group).push(this)
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger')
      this.template = this.querySelector('.overlay-lightbox__template')
      this.init()
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault()
          this.openLightbox()
        })
      }

      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox()
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault()
            this.navigateToPrevious()
          } else if (e.key === 'ArrowRight') {
            e.preventDefault()
            this.navigateToNext()
          }
        }
      })
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay()
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open')
      document.body.style.overflow = 'hidden'

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems()

        // Prefetch images for the group
        this.prefetchGroupImages()

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item')
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item')
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item')
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found')
        return
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay')

      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template')
        return
      }

      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close')
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev')
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next')

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.closeLightbox()
        })
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.navigateToPrevious()
        })
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.navigateToNext()
        })
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox()
          }
        })
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay)
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open')
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item')

        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay)
          this.overlay = null
          this.closeBtn = null
          this.prevBtn = null
          this.nextBtn = null
        }
      }

      document.body.style.overflow = ''
    }

    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || []
      this.currentIndex = this.groupItems.indexOf(this)
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return

      let targetIndex = this.currentIndex - 1
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1
      }

      const targetLightbox = this.groupItems[targetIndex]
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox)
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return

      let targetIndex = this.currentIndex + 1
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0
      }

      const targetLightbox = this.groupItems[targetIndex]
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox)
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox()

      // Open target lightbox immediately
      targetLightbox.openLightbox()
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group)

        this.groupItems.forEach((lightbox) => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img')
          images.forEach((img) => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img)
          })
        })
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map((src) => src.trim().split(' ')[0])
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src
        let largestSize = 0

        srcsetUrls.forEach((url) => {
          const size = this.extractImageSize(url)
          if (size > largestSize) {
            largestSize = size
            largestUrl = url
          }
        })

        this.prefetchImage(largestUrl)
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src)
        this.prefetchImage(largestUrl)
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url)

        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0
        }

        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_')
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/)
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0
          }
        }
      } catch (e) {
        // URL parsing failed
      }

      return 0
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl)

        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400')
          return url.toString()
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_')
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg'
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension
            url.pathname = newPath
            return url.toString()
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }

      return originalUrl
    }

    prefetchImage(url) {
      const prefetchImg = new Image()
      prefetchImg.src = url
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open')
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group)
        if (groupItems) {
          const index = groupItems.indexOf(this)
          if (index > -1) {
            groupItems.splice(index, 1)
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group)
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super()
      this.cache = new Map() // Cache for pre-fetched content
      this.activeRequests = new Map() // Track active fetch requests
      this.loadingTimeout = null // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document

      this.addEventListener('change', (event) => this.onVariantChange(event))
      this.addEventListener('mouseover', (event) => this.onMouseOver(event))
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading')
      }, 200)
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = null
      }

      // Remove loading animation
      this.classList.remove('product-hot-reload--loading')
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form')
      const sectionId = this.dataset.sectionId

      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId

      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl
        optionValueId = input.dataset.optionValueId
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex]
        newProductUrl = selectedOption.dataset.productUrl
        optionValueId = selectedOption.dataset.optionValueId
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = []

      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'))
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean)

      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'))
      selects.forEach((select) => {
        const selectedOption = select.options[select.selectedIndex]
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId)
        }
      })

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter((id) => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`)
          return input && input.name !== currentOptionName
        })
        // Add the hovered option value
        selectedOptionValues.push(optionValueId)
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : ''
      return `${newProductUrl}?section_id=${sectionId}${params}`
    }

    onMouseOver(event) {
      const label = event.target.closest('label')
      if (!label) return

      const input = label.querySelector('input[type="radio"]')
      if (!input) return

      // Don't pre-fetch if already selected
      if (input.checked) return

      const requestUrl = this.buildRequestUrl(input)

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl)
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          this.cache.set(requestUrl, html)
          this.activeRequests.delete(requestUrl)
          return html
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl)
          throw error
        })

      this.activeRequests.set(requestUrl, fetchPromise)
      return fetchPromise
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return

      const optionValueElement = event.target
      const requestUrl = this.buildRequestUrl(optionValueElement)
      const oldProductUrl = this.dataset.productUrl

      // Get new product URL from the input or selected option
      let newProductUrl
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex]
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl
      } else {
        newProductUrl = oldProductUrl
      }

      // Start loading state immediately on change event
      this.showLoadingState()

      let html

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl)
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl)
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl)
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id)
      } catch (error) {
        console.error('Error updating product content:', error)
      } finally {
        // Always hide loading state
        this.hideLoadingState()
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id)

      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML
          this.dataset.productUrl = updatedHtml.dataset.productUrl
          this.dataset.variantId = updatedHtml.dataset.variantId
        })

        // Wait for the transition to complete
        await transition.finished
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML
        this.dataset.productUrl = updatedHtml.dataset.productUrl
        this.dataset.variantId = updatedHtml.dataset.variantId
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin)

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href)
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value)
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId)

      // Push new state to browser history
      window.history.pushState({}, '', url.toString())

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus()
    }
  }

  customElements.define('product-hot-reload', ProductHotReload)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener(
        'product-form:submit:error',
        (event) => {
          if (event.target.form.id === this.dataset.formId) {
            this.displayErrorMessage(event.detail.errorMessage)
          }
        },
        { signal: this.abortController.signal }
      )

      document.addEventListener(
        'product-form:submit:success',
        (event) => {
          if (event.target.form.id === this.dataset.formId) {
            this.clearInputFields()
            this.clearErrorMessage()
          }
        },
        { signal: this.abortController.signal }
      )
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super()
      this.slides = this.querySelectorAll('.media-gallery__slide')
      this.thumbs = this.querySelectorAll('.media-gallery__thumb')
      this.prevBtn = this.querySelector('.media-gallery__nav--prev')
      this.nextBtn = this.querySelector('.media-gallery__nav--next')
      this.mainContainer = this.querySelector('.media-gallery__main')
      this.currentIndex = 0
      this.isAnimating = false
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial'

      // Touch/swipe handling
      this.touchStartX = 0
      this.touchStartY = 0
      this.touchEndX = 0
      this.touchEndY = 0
      this.minSwipeDistance = 50
    }

    connectedCallback() {
      this.init()
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true) // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver()
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev'
          this.goToSlide(index, direction)
        })
      })

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.previousSlide()
        })
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.nextSlide()
        })
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault()
          this.previousSlide()
        } else if (e.key === 'ArrowRight') {
          e.preventDefault()
          this.nextSlide()
        }
      })

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0')

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true })
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true })
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true })

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides()
      this.autoplayActiveSlideIfEligible()
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return
      if (index === this.currentIndex) return
      if (this.isAnimating) return

      const currentSlide = this.slides[this.currentIndex]
      const targetSlide = this.slides[index]

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide)

      // Reset all slides
      this.resetSlides()

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction)

      // Update UI state
      this.updateThumbnails(index)
      this.currentIndex = index

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction)

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight()
        }, 50) // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach((slide) => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next')
      })
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach((slide) => {
        slide.classList.remove('media-gallery__slide--is-animating')
      })

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)'
        this.slides.forEach((slide) => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)'
          }
        })
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)'
        this.slides.forEach((slide) => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)'
          }
        })
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active')
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active')
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return

      const activeSlide = this.slides[this.currentIndex]
      if (!activeSlide) return

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition')
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img')
      if (!img) return

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width
      const imgHeight = img.naturalHeight || img.height

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px'
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity
        const originalTransform = activeSlide.style.transform
        activeSlide.style.opacity = '1'
        activeSlide.style.transform = 'translateX(0)'
        activeSlide.style.position = 'relative'
        activeSlide.style.visibility = 'hidden'

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight

        // Restore original styles
        activeSlide.style.opacity = originalOpacity
        activeSlide.style.transform = originalTransform
        activeSlide.style.position = ''
        activeSlide.style.visibility = ''

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px'
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition')
        }, 10)
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight()
      })

      // Observe all images in the slides
      this.slides.forEach((slide) => {
        const images = slide.querySelectorAll('img')
        images.forEach((img) => {
          this.resizeObserver.observe(img)

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight()
            }
          })
        })
      })
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating')
        targetSlide.classList.add('media-gallery__slide--is-animating')

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)'
          } else {
            currentSlide.style.transform = 'translateX(100%)'
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)'
          targetSlide.classList.add('media-gallery__slide--active')

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction)
            this.scrollActiveThumbnailIntoView()
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides()
            this.autoplayActiveSlideIfEligible()
            // Clear animation flag
            this.isAnimating = false
          })
        })
      })
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active')
      targetSlide.classList.remove('media-gallery__slide--is-animating')

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)'
      } else {
        currentSlide.style.transform = 'translateX(-100%)'
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight()
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      })
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length
      this.goToSlide(nextIndex, 'next')
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1
      this.goToSlide(prevIndex, 'prev')
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd)
            resolve()
          }
        }
        element.addEventListener('transitionend', handleTransitionEnd)
      })
    }

    handleTouchStart(e) {
      if (this.isAnimating) return

      const touch = e.touches[0]
      this.touchStartX = touch.clientX
      this.touchStartY = touch.clientY
    }

    handleTouchMove(e) {
      if (this.isAnimating) return

      const touch = e.touches[0]
      this.touchEndX = touch.clientX
      this.touchEndY = touch.clientY
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return

      const deltaX = this.touchEndX - this.touchStartX
      const deltaY = this.touchEndY - this.touchStartY
      const absDeltaX = Math.abs(deltaX)
      const absDeltaY = Math.abs(deltaY)

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide()
        } else {
          // Swipe left - go to next slide
          this.nextSlide()
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : [])
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause()
        }
      })
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause())
        }
      })
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex]
      if (!activeSlide) return

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media')
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return
        if (element.hasAttribute('playing')) return
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play()
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'loaded' &&
                element.hasAttribute('loaded')
              ) {
                observer.disconnect()
                element.play()
                break
              }
            }
          })

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] })
        }
      })
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement)
  } catch(e) { console.error(e); }
})();

})();
